import { IncomeAdditionalFieldsNames } from '../../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { DropdownBooleanOptions, IDropdownChangeIncomeFieldsOption, IDropdownOption } from '../../components/form/Fields/InputDropdown/InputDropdownProps'
import { AdditionalIncomeAdditionalFieldsNames } from '../../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'


//=================== TYPY KONTROLEK HTML =================
export enum HtmlInputTypes {
  date = 'date',
  datetime =  'datetime',
  email = 'email', 
  number = 'number',
  tel = 'tel',
  text = 'text',
  time = 'time',
}


// ============================== TYPY PÓL ====================
export enum FieldTypes {
  string = 'string',
  email = 'email',
  phone = 'phone',
  dropdown = 'dropdown',
  dropdownChangeIncomeTypeField = 'dropdownChangeIncomeTypeField',
  boolean = 'boolean',
  date = 'date',
  datetime = 'datetime',
  number = 'number',
}

// ============= TYPY KLAWIATUR NA URZĄDZENIACH MOBILNYCH =============
// Atrybuty według specyfikacji: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode

export enum InputModes {
  text = 'text',
  decimal = 'decimal',
  numeric = 'numeric',
  tel = 'tel',
  search = 'search',
  email = 'email',
  url = 'url',
  none = 'none'
}

export type TFieldsType = IFieldString | IFieldDropdown | IFieldDate | IFieldNumber | IFieldBoolean | IDropdownActionOnChange 

export interface IFields {
  [key: string]: TFieldsType
}


// =================== KLASA BAZOWA POLA DO DZIEDZICZENIA ======================= 
export interface IFieldBase {
    order?: number;
    name: string
    label: string;
    maxLength?: number;
    editable?: boolean;
    placeholder?: string;
    tip?: string;
    mask?: string | undefined;
    isPasteDisabled?: boolean;
    actionOnValueChange?: Function;
    isAdditionalField?: boolean;
}

// ===================== POLE Z WYBOREM TAK / NIE =====================
export interface IFieldBoolean extends Omit<IFieldBase, 'maxLength' | 'placeholder' | 'mask' | 'action' > {
  type: FieldTypes.boolean;
  associatedFieldName?: IncomeAdditionalFieldsNames | AdditionalIncomeAdditionalFieldsNames; //Nazwa pola które może pojawić się po wybraniu opcji pozytywnej "Tak". 
  defaultValue?: string;
  options: DropdownBooleanOptions;
  handleOnChange?: (value: string) => void; 
  parser?: undefined;
}

//============================= POLE TEKSTOWE ==========================
export interface IFieldString extends IFieldBase {
  type: FieldTypes.string | FieldTypes.email | FieldTypes.phone;
  defaultValue?: string;
  inputMode?: keyof typeof InputModes;
  parser?: (newValue: string) => string;
  suggestionsProvider?: (query: string) => Promise<string[]>;
  suggestionsMinLength?: number;
  handleOnChange?: (value: string) => void; 
}

// ============================== POLE Z LISTĄ ROZWIJALNĄ ==========================
export interface IFieldDropdown extends Omit<IFieldBase, 'maxLength' | 'mask'> {
    type: FieldTypes.dropdown;
    options: IDropdownOption[];
    defaultValue?: string;
    parser?: (newValue: string) => string;
    handleOnChange?: (value: string[]) => void; 
}

export interface IDropdownActionOnChange extends Omit<IFieldDropdown, 'type' | 'options' | 'parser' |'handleOnChange' | 'value' > {
  type:  FieldTypes.dropdownChangeIncomeTypeField;
  options: IDropdownChangeIncomeFieldsOption[];
  parser?: undefined;
  handleOnChange?: (value: IDropdownChangeIncomeFieldsOption[]) => void; 
}

// =========================== POLE Z DATĄ ==================================
export interface IFieldDate extends Omit<IFieldBase, 'mask' | 'maxLength'> {
  type:  FieldTypes.date | FieldTypes.datetime;
  defaultValue?: string;
  inputMode?: keyof typeof InputModes;
  parser?: (newValue: string) => string;
  handleOnChange?: (value: Date) => void; 
}

// ============================= POLE LICZBOWE ==============================
export interface IFieldNumber extends IFieldBase {
  type: FieldTypes.number;
  defaultValue?: string;
  parser?: (newValue: string) => string;
  handleOnChange?: (value: string) => void; 
}